import { render, staticRenderFns } from "./tempPublicationList.vue?vue&type=template&id=72f7f970&scoped=true"
import script from "./tempPublicationList.vue?vue&type=script&lang=js"
export * from "./tempPublicationList.vue?vue&type=script&lang=js"
import style0 from "./tempPublicationList.vue?vue&type=style&index=0&id=72f7f970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7f970",
  null
  
)

export default component.exports